import { Typography, TypographyProps } from '@mui/material';
import React, { ElementType } from 'react';

interface TypographyComponentProps extends TypographyProps {
  verticalAlign?: string;
  textGradient?: string;
  opacity?: string | number;
  component?: ElementType<any, any> | undefined;
  href?: string;
}

const TypographyComponent = ({
  children,
  ...rest
}: TypographyComponentProps) => {
  return <Typography>{children}</Typography>;
};

export default TypographyComponent;
